import { PanelLinksItem } from "@/types/generated/DifcamWebTypes";

import { BaseService } from "./BaseService";

export class PanelLinksService extends BaseService {
  getPanelLinksItems(): Promise<PanelLinksItem[]> {
    return this.get<PanelLinksItem[]>(`/panel-links`);
  }
}
